import React from "react";
import { useDispatch } from "react-redux";
import { Creators } from "@Src/redux/actionTypes";

/**
 * GetIP component.
 *
 * @param {Object} props - The component props.
 * @param {React.ReactNode} props.children - The children components.
 * @returns {React.ReactNode} - The rendered component.
 */
const GetIP = ({ children }) => {
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(Creators.fetchIp());
  }, [dispatch]);

  return children;
};

export default GetIP;
